import { Button } from "@/components/ui/button";

/**
 * Quick presets for HACCP freezer/cooler temperatures.
 * Tap-friendly chips that set the numeric value directly.
 */
const DEFAULT_PRESETS = [-18, -20, -22];

export default function TempPresetButtons({
  presets = DEFAULT_PRESETS,
  onSelect,
  "data-testid": testId = "temp-presets",
}) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {presets.map((v) => (
        <Button
          key={v}
          type="button"
          size="sm"
          variant="outline"
          className="h-7 px-2.5 text-xs font-mono"
          onClick={() => onSelect?.(String(v))}
          data-testid={`temp-preset-${v}`}
        >
          {v}°C
        </Button>
      ))}
    </div>
  );
}
